<template>
  <section class="px-8">
    <div>
      <div class="flex flex-col items-center py-2 justify-center gap-y-2">
        <h3 class="text-2xl font-semibold mt-1">
          {{
            parseMoneyAll(
              transactionDetails.amount,
              transactionDetails.currency
            )
          }}
        </h3>
        <p
          class="text-sm font-normal text-fg-subtle text-center"
          style="word-break: normal"
        >
          This transaction requires your authorization to proceed
        </p>
        <p
          class="text-sm font-normal text-center text-fg-subtle"
          style="word-break: normal"
          v-if="isWireTransfer"
        >
          Wire transfer transactions may take 2-4 business days before clearing
        </p>
        <p
          class="text-xs text-center font-normal rounded-lg px-1.5 py-2 capitalize mt-3 mb-2"
          :class="statusClass(transactionDetails.status)"
        >
          {{ formatServerName(transactionDetails.status) }}
        </p>
      </div>
    </div>
    <div class="text-fg-muted">
      <ul>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span>Time & Date</span>
          <span>{{ parseRelativeTime(transactionDetails.createdAt) }}</span>
        </li>
        <li
          class="grid grid-cols-2 font-normal text-sm items-center border-b py-3.5 lg:py-6"
        >
          <span>Transaction ID</span>
          <span
            >{{ maskID(transactionDetails.id) || '--' }}
            <span
              class="cursor-pointer mb-1 ml-2"
              v-clipboard:copy="transactionDetails.id"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >
              <copy-icon />
            </span>
          </span>
        </li>
        <!-- <li
          class="grid grid-cols-2 items-center text-sm font-normal border-b py-3.5 lg:py-6"
        >
          <span>Payment Method</span>
          <span class="flex items-center gap-x-2">
            <span class="capitalize">{{
              formatServerName(transactionDetails.method) || '--'
            }}</span>
          </span>
        </li>
        <li
          class="grid grid-cols-2 items-center text-sm font-normal border-b py-3.5 lg:py-6"
        >
          <span>Reference/Notes</span>
          <span class="flex items-center gap-x-2">
            <span class="capitalize">{{
              transactionDetails.reference || '--'
            }}</span>
          </span>
        </li> -->
        <!-- commented out pending when we can access the Withdrawal details -->
        <!-- <li
          v-if="!isCurrencySwap"
          class="flex justify-between font-normal text-sm items-center py-3.5 lg:py-5 cursor-pointer select-none"
          @click="toggleShow('showWithdrawalDetails')"
        >
          <span>Withdrawal Details</span>
          <span class="text-primary font-semibold text-2xl">{{
            showWithdrawalDetails ? '-' : '+'
          }}</span>
        </li>
        <transition name="slide-fade">
          <div v-if="showWithdrawalDetails" style="word-break: normal">
            <div class="pt-3" v-if="isBankTransfer" style="word-break: normal">
              <div
                v-for="(detail, index) in transferDetails"
                :key="index"
                class="flex flex-row border rounded-md py-3.5 lg:py-5 bg-surface px-3 justify-between items-center mb-3"
              >
                <p class="text-sm font-thin">{{ detail.key }}</p>
                <div class="flex items-center gap-x-3">
                  <p class="text-sm font-semibold">
                    {{ detail.value || '--' }}
                  </p>
                  <div
                    class="cursor-pointer"
                    v-clipboard:copy="detail.value"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <copy-icon />
                  </div>
                </div>
              </div>
              <div
                class="flex flex-row border rounded-md py-3.5 lg:py-5 bg-surface px-3 justify-between items-center mb-3"
              >
                <p class="text-sm font-thin">Reference</p>
                <div class="flex items-center gap-x-3">
                  <p class="text-sm font-bold">
                    {{ maskID(transactionDetails.reference) || '--' }}
                  </p>
                  <div
                    class="cursor-pointer mb-1 ml-2"
                    v-clipboard:copy="transactionDetails.reference"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <copy-icon />
                  </div>
                </div>
              </div>
            </div>
            <div class="pt-3" v-if="isLocalTransfer" style="word-break: normal">
              <div v-for="(detail, index) in transferDetails" :key="index">
                <div
                  v-if="valueExists(detail.value)"
                  class="flex flex-row border rounded-md py-3.5 lg:py-5 bg-surface px-3 justify-between items-center mb-3"
                >
                  <p class="text-sm font-thin">{{ detail.key }}</p>
                  <div class="flex items-center gap-x-3">
                    <p class="text-xs font-semibold">
                      {{ detail.value || '--' }}
                    </p>
                    <div
                      class="cursor-pointer mb-1 ml-2"
                      v-clipboard:copy="detail.value"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      <copy-icon />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isAssetTransfer" class="mt-3">
              <div
                v-for="(item, index) in bankDetails"
                :key="index"
                class="flex flex-row border rounded-md py-3.5 lg:py-5 bg-surface px-3 justify-between items-center mb-3"
              >
                <p class="text-sm font-thin">{{ item.key }}</p>
                <div class="flex items-center gap-x-3">
                  <p class="text-xs font-semibold">{{ item.value || '--' }}</p>
                  <div
                    class="cursor-pointer mb-1 ml-2"
                    v-clipboard:copy="item.value"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <copy-icon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition> -->
      </ul>
    </div>
  </section>
</template>

<script>
import {
  ParseMoneyAll,
  ParseMoney,
  MaskWalletAddressTwo,
  StatusClass,
  FormatServerName,
  ParseRelativeTime
} from '@/utils/helpers.js'
import app from '@/mixins/app'

export default {
  mixins: [app],
  props: {
    transactionDetails: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showWithdrawalDetails: false
    }
  },
  methods: {
    parseRelativeTime (time) {
      return ParseRelativeTime(time)
    },
    statusClass (status) {
      return StatusClass(status)
    },
    formatServerName (val) {
      return FormatServerName(val)
    },
    handleClose () {
      this.$emit('closeDrawer')
    },
    toggleShow (arg) {
      this[arg] = !this[arg]
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    maskID (val) {
      return MaskWalletAddressTwo(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    parseMoney (amount) {
      return ParseMoney(amount)
    },
    valueExists (val) {
      return val && val.length > 0
    }
  },
  components: {
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  },
  computed: {
    isWireTransfer () {
      return (
        this.transactionDetails.method === this.$transactionType.WIRE_TRANSFER
      )
    },
    isLocalTransfer () {
      return (
        this.transactionDetails.method === this.$transactionType.LOCAL_TRANSFER
      )
    },
    isCurrencySwap () {
      return (
        this.transactionDetails.method === this.$transactionType.CURRENCY_SWAP
      )
    },
    displayTimeDate () {
      const timeToPick =
        this.transactionDetails.status === this.$STATUS.COMPLETED
          ? this.transactionDetails.createdAt
          : this.transactionDetails.createdAt
      return this.tooltipDateContent(timeToPick)
    }
  }
}
</script>
